import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 8a8 8 0 1 1 8 8 8.01 8.01 0 0 1-8-8m2 0a6 6 0 1 0 12 0A6 6 0 0 0 2 8m5 3V9H5a1 1 0 1 1 0-2h2V5a1 1 0 0 1 2 0v2h2a1 1 0 1 1 0 2H9v2a1 1 0 1 1-2 0" }));
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
